import CommonService from '@/shared/services/SystemKeyService'
import type { SystemkeyModel } from '@/shared/types'
import { useQuery } from '@tanstack/react-query'
import { QUERY_COMMON_KEY } from '../query.constant'

export const useGetCommonQuery = () =>
  useQuery<SystemkeyModel[]>({
    queryKey: [QUERY_COMMON_KEY],
    queryFn: async () => {
      const res = await CommonService.getSystemKey()
      return res.object
    },
    staleTime: 20000,
  })
// Ví dụ:
// const { data: systemKey, isLoading, error } = useGetSystemKeyQuery();

// Ví dụ khác
// export const useCommonData = () => {
//   return useQueries({
//     queryKey: [QUERY_COMMON_KEY],
//     queries: [
//       {
//         queryKey: commonQueryKeys.systemKey(),
//         queryFn: getSystemKey,
//         staleTime: 20_000,
//       },
//       {
//         queryKey: commonQueryKeys.permission(),
//         queryFn: getPermission,
//         staleTime: 20_000,
//       },
//     ],
//     staleTime: 20000,
//   });
// };

//dùng trong component
// const [systemKeyQuery, permissionQuery] = useCommonData();

// if (systemKeyQuery.isLoading || permissionQuery.isLoading) {
//   return <Spinner />;
// }

//dùng useMutation là hook của React Query dùng để THAY ĐỔI dữ liệu trên server
